import { defineComponent as _defineComponent } from 'vue'
import ExpandIcon from '@/assets/images/svg/expand.svg?component';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableVulnerabilitySection',
  props: {
    title: null,
    testingMethodText: null,
    expanded: { type: Boolean },
    accordionClassNames: null
  },
  emits: ["toggle"],
  setup(__props: any, { emit }: { emit: ({ (e: 'toggle', isExpanded: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title: string;
  testingMethodText: 'sast' | 'dast';
  expanded: boolean;
  accordionClassNames?: string;
};





function toggleExpanded() {
  emit('toggle', !props.expanded);
}

return { __sfc: true,props, emit, toggleExpanded, ExpandIcon }
}

})